import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'
import { css } from 'aphrodite'

import style from './style'

export const FileSystem = props => {
  return (
    <Row className={css(style.navigation.wrapper)}>
      <Col className={css(style.navigation.innerWrapper)}>
        {props.fileList.map((route, index) => (
          <RenderLink
            key={`${route.title}_${index}_fs`}
            currentPath={props.currentPath}
            onClick={() => props.onFileSelect(route.path)}
            root
            {...route}
          />
        ))}
      </Col>
    </Row>
  )
}

const RenderLink = props => {
  const path = `/dashboard/settings/motd?file=${props.path}`
  const isActive = props.currentPath === props.path

  return (
    <Row>
      <Col
        className={css(style.navigation.row)}
        style={!props.root ? { marginLeft: `10px` } : {}}
      >
        <Link
          to={path}
          onClick={props.onClick}
          className={css(
            style.navigation.link,
            isActive ? style.navigation.activeLink : null
          )}
        >
          <i
            className={`
            ${css(style.navigation.icon)} fas fa-${
              props.isDirectory ? 'folder' : 'file'
            }
          `}
          />
          {props.title}
        </Link>
        {props.isDirectory
          ? props.content.map((route, index) => (
            <RenderLink
              key={`${route.title}_${index}_fs`}
              currentPath={props.currentPath}
              {...route}
              />
            ))
          : null}
      </Col>
    </Row>
  )
}

export default FileSystem



// WEBPACK FOOTER //
// ./src/components/Settings/Motd/partials/FileSystem/index.js